module.exports = __webpack_public_path__ + "static/img/St-Kilda.461218f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/St-Kilda.jpg
// module id = W/HL
// module chunks = 1